import { useCallback, useState } from 'react'

import { KojinResult } from 'interface/kojin'
import { KojinAnnotateResult, usePostKojinAnnotate } from 'interface/kojin/annotate'

import {
  ToggleButton, ToggleButtonGroup, Stack, TextField, Box, Button
} from "@mui/material"

import { ValidIcon, DontIcon, NoCareIcon } from 'shared/icons'
import { Loading } from 'components/controls/loading'

type TargetListRecordAnnotateFormProps = {
  searchId: number
  targetListId: number
  kojin: KojinResult
  onChangeAnnotate: (kojinCode: string, annotate: KojinAnnotateResult) => void
}
export const TargetListRecordAnnotateForm = ({
  searchId,
  targetListId,
  kojin,
  onChangeAnnotate
}: TargetListRecordAnnotateFormProps) => {
  const [score, setScore] = useState<number>(kojin.annotate?.score ?? 0)
  const [reason, setReason] = useState<string>(kojin.annotate?.reason ?? '')

  const onPostedAnnotate = useCallback(
    (result: KojinAnnotateResult) => {
      onChangeAnnotate(kojin.kojinCode ?? '', result)
    },
    [kojin, onChangeAnnotate]
  )
  const [postState, post] = usePostKojinAnnotate(searchId, targetListId, kojin.kojinCode, {
    onPosted: onPostedAnnotate
  })
  return (
    <Stack direction='row' padding={1} spacing={1}>
      {postState.posting && <Loading/>}

      <ToggleButtonGroup
        size="small"
        aria-label="score"
        value={score}
        onChange={(event, value) => {
          setScore(value)
          const kojinCode = kojin.kojinCode
          if (!kojinCode) return
          post({
            score: value,
            reason: value === 0 ? undefined : reason
          })
        }}
        exclusive
      >
        <ToggleButton value={0} key="ok" color='primary'><ValidIcon style={{ marginRight: '8px' }}/>妥 当</ToggleButton>      
        <ToggleButton value={1} key="dont" color='warning'><DontIcon style={{ marginRight: '8px' }}/>微 妙</ToggleButton>      
        <ToggleButton value={2} key="nocare" color='error'><NoCareIcon />不適切</ToggleButton>      
      </ToggleButtonGroup>

      { score > 0 && (
        <Box flexGrow={1}>
          <TextField
            id="reason"
            label="理由"
            type="search"
            variant="outlined"
            defaultValue={reason}
            size="small"
            onChange={(event) => setReason(event.target.value)}
            fullWidth
          />
        </Box>
      ) }
      { score > 0 && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            const kojinCode = kojin.kojinCode
            if (!kojinCode) return
            post({ score, reason })
          }}
        >
          保存
        </Button>
      )}
    </Stack>
  )
}